import { RouteConfig } from 'vue-router';

// eslint-disable-next-line no-shadow
export enum CheeersLayout {
  DEFAULT = 'default',
  BLANK = 'blank',
}

export interface CheeersLayoutConfig {
  name: CheeersLayout;
  showAppBar?: boolean;
  showDrawer?: boolean;
  showFooter?: boolean;
}

export interface CheeersRouteMeta {
  children?: CheeersRouteConfig[];
  meta?: {
    noNeedLoggedIn?: boolean;
    layout?: CheeersLayout | CheeersLayoutConfig;
  };
}

export type CheeersRouteConfig = RouteConfig & CheeersRouteMeta;

const routes: CheeersRouteConfig[] = [
  {
    path: '/',
    redirect: '/mission',
  },
  {
    path: '/issue',
    component: () => import('../views/Issue/Issue.vue'),
    meta: {
      layout: {
        name: CheeersLayout.DEFAULT,
        showFooter: false,
      },
    },
    children: [
      {
        path: ':id',
        name: 'Issue',
        component: () => import('../views/Issue/IssueDetail.vue'),
        meta: {
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
      },
    ],
  },
  {
    path: '/setting',
    component: () => import('../views/Setting/Setting.vue'),
    children: [
      {
        name: 'Setting',
        path: '/',
        redirect: 'profile',
      },
      {
        path: 'profile',
        name: 'Setting profile',
        component: () => import('@/views/Setting/SubPage/Profile.vue'),
        meta: {
          titleLang: 'profile.title',
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
      },
      {
        path: 'language',
        name: 'Setting language',
        component: () => import('@/views/Setting/SubPage/Language.vue'),
        meta: {
          titleLang: 'setting.languageSetting',
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
      },
      {
        path: 'point',
        name: 'Setting point',
        component: () => import('@/views/Setting/SubPage/Point.vue'),
        meta: {
          titleLang: 'setting.pointSetting',
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
      },
      // {
      //   path: 'notification',
      //   name: 'Setting notification',
      //   component: () => import('@/views/Setting/SubPage/Notification.vue'),
      //   meta: {
      //     titleLang: 'setting.notificationSetting',
      //   },
      // },
      {
        path: 'password',
        name: 'Setting password',
        component: () => import('@/views/Setting/SubPage/Password.vue'),
        meta: {
          titleLang: 'setting.passwordSetting',
        },
      },
    ],
  },
  {
    path: '/thanks',
    component: () => import('@/views/Thanks.vue'),
    meta: {
      layout: {
        name: CheeersLayout.DEFAULT,
        showFooter: false,
      },
    },
    children: [
      {
        name: 'Thanks',
        path: '/',
        redirect: 'add',
        meta: {
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
      },
      {
        path: 'add',
        name: 'Add Thanks',
        component: () =>
          import('@/components/ViewComponent/Thanks/AddThanksMessage/AddThanksMessagePc.vue'),
        meta: {
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
      },
      {
        path: ':filter',
        name: 'Thanks For You',
        component: () =>
          import('@/components/ViewComponent/Thanks/ThanksMessage/ThanksMessagePc.vue'),
        meta: {
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
      },
    ],
  },
  {
    path: '/e-learning',
    component: () => import('@/views/ELearning/ELearning.vue'),
    meta: {
      layout: {
        name: CheeersLayout.DEFAULT,
        showFooter: false,
      },
    },
    children: [
      {
        path: '/',
        name: 'E Learning all',
        component: () => import('@/views/ELearning/SubPage/Index.vue'),
        meta: {
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
      },
      {
        path: 'learn/:id',
        name: 'Learning',
        component: () => import('@/views/ELearning/SubPage/Learn.vue'),
        meta: {
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
        props: ({ params }) => ({
          lessonId: Number(params.id),
          key: params.id,
        }),
      },
      {
        path: 'test/survey-question',
        name: 'Survey Question Test',
        component: () => import('@/views/ELearning/SubPage/SurveyQuestionTest.vue'),
        meta: {
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
      },
      {
        path: 'test/:id',
        name: 'Testing',
        component: () => import('@/views/ELearning/SubPage/DoingTest.vue'),
        meta: {
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
        props: ({ params }) => ({
          lessonId: Number(params.id),
          key: params.id,
        }),
      },
      {
        path: 'result/:id',
        name: 'TestResult',
        component: () => import('@/views/ELearning/SubPage/TestResult.vue'),
        meta: {
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
        props: ({ params }) => ({
          lessonId: Number(params.id),
          key: params.id,
        }),
      },
      {
        path: ':id',
        name: 'E Learning',
        component: () => import('@/views/ELearning/SubPage/Index.vue'),
        meta: {
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
        props: ({ params }) => ({
          categoryId: Number(params.id),
          key: params.id,
        }),
      },
    ],
  },
  {
    path: '/exchange',
    component: () => import('../views/Exchange/Exchange.vue'),
    meta: {
      layout: {
        name: CheeersLayout.DEFAULT,
        showFooter: false,
      },
    },
    children: [
      {
        path: 'history',
        name: 'Exchange history',
        component: () => import('@/views/Exchange/SubPage/History.vue'),
        meta: {
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
      },
      {
        path: '/',
        name: 'Benefit',
        component: () => import('@/views/Exchange/SubPage/Index.vue'),
        props: () => ({ categoryId: 0, key: 0 }),
        meta: {
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
      },
      {
        path: ':id',
        component: () => import('@/views/Exchange/SubPage/Index.vue'),
        props: ({ params }) => ({
          categoryId: Number(params.id),
          key: params.id,
        }),
      },
    ],
  },
  {
    path: '/attendance',
    component: () => import('../views/Attendance/Attendance.vue'),
    children: [
      {
        path: '/',
        name: 'Attendance',
        component: () => import('@/views/Attendance/SubPage/Index.vue'),
      },
      {
        path: '/time-stamp',
        name: 'Time Stamp',
        component: () => import('@/views/Attendance/SubPage/AttendanceManagement.vue'),
      },
    ],
  },
  {
    path: '/bulletin',
    name: 'Bulletin',
    component: () => import('../views/Bulletin/Bulletin.vue'),
    children: [
      {
        path: 'create',
        name: 'create Bulletin',
        component: () => import('../views/Bulletin/BtnCreateBulletin.vue'),
        meta: {
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
      },
      {
        path: ':id',
        name: 'Bulletin detail',
        component: () => import('../views/Bulletin/BulletinDetail.vue'),
        meta: {
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      noNeedLoggedIn: true,
      layout: {
        name: CheeersLayout.BLANK,
        showAppBar: false,
        showDrawer: false,
        showFooter: false,
      },
    },
  },
  {
    path: '/forgot-password',
    component: () => import('../views/ForgotPassword/ForgotPassword.vue'),
    children: [
      {
        path: '/',
        name: 'Forgot password',
        component: () => import('../views/ForgotPassword/SubPage/EmailChallenge.vue'),
        meta: {
          noNeedLoggedIn: true,
          layout: {
            name: CheeersLayout.BLANK,
            showAppBar: false,
            showDrawer: false,
            showFooter: false,
          },
        },
      },
      {
        path: 'otp-challenge',
        component: () => import('../views/ForgotPassword/SubPage/OtpChallenge.vue'),
        meta: {
          noNeedLoggedIn: true,
          layout: {
            name: CheeersLayout.BLANK,
            showAppBar: false,
            showDrawer: false,
            showFooter: false,
          },
        },
      },
      {
        path: 'change-password',
        component: () => import('../views/ForgotPassword/SubPage/ChangePassword.vue'),
        meta: {
          noNeedLoggedIn: true,
          layout: {
            name: CheeersLayout.BLANK,
            showAppBar: false,
            showDrawer: false,
            showFooter: false,
          },
        },
      },
    ],
  },
  {
    path: '/under-maintenance',
    name: 'Maintenance',
    component: () => import('../views/Maintenance/index.vue'),
    meta: {
      noNeedLoggedIn: true,
      layout: {
        name: CheeersLayout.BLANK,
        showAppBar: false,
        showDrawer: false,
        showFooter: false,
      },
    },
  },
  {
    path: '/mission',
    component: () => import('@/views/Mission/Index.vue'),

    children: [
      {
        path: '/',
        name: 'Mission',
        component: () => import('@/views/Mission/Subpage/MissionDetail.vue'),
        meta: {
          layout: {
            name: CheeersLayout.DEFAULT,
            showFooter: false,
          },
        },
      },
    ],
  },
];

export default routes;
